var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseEChart',{staticStyle:{"width":"100%","height":"78vh","position":"relative","top":"-15px"},attrs:{"option":_vm.option}})}
var staticRenderFns = []

export { render, staticRenderFns }